import { createClient } from "@supabase/supabase-js";

const url = import.meta.env["VITE_SUPABASE_URL"];
const anonKey = import.meta.env["VITE_SUPABASE_ANON_KEY"];

if (!url || !anonKey) {
  throw new Error(
    "Faltan VITE_SUPABASE_URL o VITE_SUPABASE_ANON_KEY. Revisa el .env del admin.",
  );
}

/**
 * Supabase aquí se usa SOLO para autenticación.
 *
 * Los datos nunca se leen directo de Postgres desde el navegador: todo pasa
 * por la API. Si el frontend consultara tablas por su cuenta, la lógica de
 * autorización viviría en dos lugares (RLS y NestJS) y tarde o temprano
 * dirían cosas distintas.
 */
export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

// Solo en desarrollo: permite abrir sesión desde la consola del navegador
// con un token emitido por `pruebas/token.ts`, sin teclear la contraseña.
// Vite elimina este bloque del bundle de producción.
if (import.meta.env.DEV) {
  (globalThis as unknown as { supabase: typeof supabase }).supabase = supabase;
}

export async function tokenDeAcceso(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}
